import { ReactElement } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  name: string;
  label?: string;
  placeholder?: string;
  className?: string;
  leadingIconLeft?: ReactElement<any>;
  leadingIconRight?: ReactElement<any>;
  validationError?: boolean;
}

const Input = ({
  id,
  name,
  className,
  placeholder,
  label,
  leadingIconLeft,
  leadingIconRight,
  validationError,
  ...props
}: InputProps) => {
  return (
    <div>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium mb-2">
          {`${label.charAt(0).toUpperCase()}${label.slice(1, label.length)}`}
        </label>
      )}

      <div className="relative">
        <input
          {...props}
          type={props.type ?? 'text'}
          id={id}
          name={name}
          className={`${className} py-[14px] px-4 block w-full rounded-lg text-sm focus:z-10 disabled:pointer-events-none disabled:bg-gray-100 ${validationError ? 'input-control-error' : 'input-control-no-border'} ${leadingIconLeft ? 'ps-11' : ''} ${leadingIconRight ? 'pe-11' : ''}`}
          placeholder={
            placeholder != undefined
              ? `${placeholder.charAt(0).toUpperCase()}${placeholder.slice(1, placeholder.length)}`
              : ''
          }
        />
        {leadingIconLeft && (
          <label
            htmlFor={id}
            className="absolute inset-y-0 start-0 flex items-center z-20 px-4 text-gray-500"
          >
            {leadingIconLeft}
          </label>
        )}
        {leadingIconRight && (
          <div className="absolute inset-y-0 end-0 flex items-center z-20 px-4 text-gray-500">
            {leadingIconRight}
          </div>
        )}
      </div>
    </div>
  );
};

export default Input;
